'use client';
import { useEffect } from 'react';
import { initBasketSync } from '@/lib/BasketStorage';

export default function BasketSyncProvider() {
  useEffect(() => {
    initBasketSync();
  }, []);

  return null;
}
